// icons
import { ReactComponent as CaretIcon } from './../../../../assets/svg/bottom-arrow.svg';
import styles from './FaqItem.module.css';
import useFaqItem from './useFaqItem';

const FaqItem = ({ title, keyword = '', description }) => {
  const [descriptionRef, show, setShow, descriptionHeight] = useFaqItem(description);

  let splitList = [];
  if (!keyword) {
    splitList.push({ type: 'normal', value: title });
  } else {
    const splited = title.split(keyword).map((item) => ({ type: 'normal', value: item }));
    splited.splice(1, 0, { type: 'bold', value: keyword });

    splitList = splited;
  }

  splitList = splitList.filter((item) => !!item.value);

  return (
    <div className={styles.FaqItemContainer} onClick={() => setShow(!show)}>
      <div className={styles.Header}>
        <div className={`${styles.Caret} ${show ? styles.Active : ''}`}>
          <CaretIcon className={styles.CaretIcon} />
        </div>
        <span style={{ fontWeight: show ? 'bold' : 'normal' }}>
          {splitList.map((splitItem, i) => (
            <span
              key={i}
              className={`${splitItem.type === 'normal' ? styles.NormalText : styles.BoldText}`}>
              {splitItem.value}
            </span>
          ))}
        </span>
      </div>
      {show ? (
        <hr style={{ width: '100%', borderBottom: '1px solid #BBBBBB', marginTop: '10px' }} />
      ) : null}
      <div
        className={`${styles.DescriptionContainer} ${show ? styles.Show : ''}`}
        style={{ height: show ? descriptionHeight : 0 }}>
        <span ref={descriptionRef} className={styles.Description}>
          {description}
        </span>
      </div>
    </div>
  );
};

export default FaqItem;
